import { addCommas } from "./commons/commonPricing";
import { triggerChange } from "./commons/eventTarget";

const currencySelector = document.querySelector('.currency');
const viewMoreCountries = document.querySelector('.view-more-countries');
const viewMoreButton = document.querySelector('#see-more-countries');



const setSmsStateButton = () => {

  // Comprueba si existe un plan de SMS y un estado de botón guardado en el sessionStorage
  if (
    document.querySelector('.plan-prices section').classList.contains('plan-sms') &&
    !!sessionStorage.getItem('pricingGridSmsButtonState')
  ) {
    const stateButton = sessionStorage.getItem('pricingGridSmsButtonState');
    const textButton = document.getElementById('see-more-countries').getAttribute(stateButton);

    if (stateButton == 'attr-see-more') {
      document.querySelector('.view-more-countries').classList.remove('active');
      document.querySelector('.all-countries').style.display = 'none';
    } else {
      document.querySelector('.view-more-countries').classList.add('active');
      document.querySelector('.all-countries').style.display = 'block';
    }

    document.getElementById('see-more-countries').textContent = textButton;
  }

}

const viewMoreCountriesListener = () => {

  viewMoreCountries.addEventListener('click', (e) => {
    viewMoreCountries.classList.toggle('active');
  });

}

const viewMoreButtonListener = () => {

  const allCountries = document.querySelector('.all-countries');
  viewMoreButton.addEventListener('click', (e) => {
    const that = e.currentTarget;
    allCountries.style.display != 'block' ?  allCountries.style.display = 'block': allCountries.style.display = 'none';
    const text = allCountries.style.display === 'none' ? that.getAttribute('attr-see-more') : that.getAttribute('attr-see-less');
    const state = allCountries.style.display === 'none' ? 'attr-see-more' : 'attr-see-less';
    that.textContent = text;
    that.setAttribute('attr-state', state);
    sessionStorage.setItem('pricingGridSmsButtonState', state);
  });

}


const inputRangeSmsListener = () => {

  const valuesSms = [500, 1500, 5000, 10000, 20000, 50000];
  const inputSms = document.getElementById('plan-sms-input');

  if (inputSms) {
    inputSms.addEventListener('change', () => {
      const planSmsOutput = document.querySelector('#plan-sms-output span');
      planSmsOutput.innerHTML = valuesSms[inputSms.value];
      inputSms.setAttribute('data-value', valuesSms[inputSms.value]);
      document.querySelectorAll('#sms-grid-plans .row').forEach(row => {
        const smsPrice = row.querySelector('.sms-price').getAttribute('data-price');
        const smsBudget = document.querySelector('#plan-sms-input').getAttribute('data-value');
        row.querySelector('.column .price .value').innerHTML = addCommas(Math.round(smsBudget * smsPrice));
      });
      triggerChange(currencySelector);
    });
    triggerChange(inputSms);
  }

}

const loadSmsPrices = () => {

  const smsProgressRange = document.querySelector('#sms-progress-bar .range-slider');
  const currencySelector = document.querySelector('.currency');
  const planSmsInput = document.querySelector('#plan-sms-input');
  const planSmsOutputSpan = document.querySelector('#plan-sms-output span');

  const progressChangeSMS = (event) => {
    const input = event.target;
    const value = input.dataset.value;
    const parent = input.parentNode;
    const max = input.max;
    const quote = planSmsInput.value;
    const progress = (quote * 100) / max;

    parent.querySelector('.range-value').setAttribute('data-progress', parseInt(progress));
    parent.querySelector('.range-value span').innerHTML = value;
    parent.querySelector('.progress-anchor').style.width = progress + '%';
  };

  const updateCurrency = (currencyName, currencySymbol, currencyRate) => {
    document.querySelectorAll('.currency').forEach(el => {
      el.value = currencyName;
    });

    document.querySelectorAll('.price').forEach(el => {
      const rowSms = el.closest('.row').querySelector('.sms-price');
      let vCalcPrice = rowSms.getAttribute('data-price') * currencyRate;
      rowSms.querySelector('.cur-symbol').textContent = currencySymbol;
      rowSms.querySelector('b').textContent = vCalcPrice.toFixed(5);
      let valueRangeSms = planSmsOutputSpan.innerHTML;
      vCalcPrice = Math.round(vCalcPrice * valueRangeSms);
      el.querySelector('.value').textContent = addCommas(vCalcPrice);
      el.querySelector('.cur-symbol').textContent = currencySymbol;
      document.querySelectorAll('.cur-symbol').forEach(function (symbol) {
        if (symbol.innerHTML === 'euro') {
          symbol.innerHTML = '€';
        }
      });
    });

    document.querySelectorAll('.unit-price').forEach(el => {
      let value = (el.getAttribute('data-value') * currencyRate).toFixed(5);
      el.querySelector('b').innerHTML = value;
      el.querySelector('.cur-symbol').textContent = currencySymbol;
    });

    document.querySelectorAll('.old-price .cur-symbol').forEach(el => {
      el.textContent = currencySymbol;
    });

    document.querySelectorAll('.grid-planes .price, .grid-planes .unit-price, .grid-sms .price').forEach(el => {
      el.style.opacity = '1';
    });
  };

  const activeSmsProggresRangeListeners = () => {
    smsProgressRange.addEventListener('change', progressChangeSMS);
    smsProgressRange.addEventListener('input', progressChangeSMS);
  };

  const activeSmsSelectorListener = () => {
    currencySelector.addEventListener('change', () => {
      const selectedIndex = currencySelector.options.selectedIndex;
      const currencyName = currencySelector.value;
      const currencySymbol = currencySelector.options[selectedIndex].getAttribute("data-currency");
      const currencyRate = parseFloat(currencySelector.options[selectedIndex].getAttribute("data-rate"));

      updateCurrency(currencyName, currencySymbol, currencyRate);
    });
  };

  const dispatchEvents = () => {
    smsProgressRange.dispatchEvent(new Event('change'));
    currencySelector.dispatchEvent(new Event('change'));
  };

  const startSmsValues = () => {
    activeSmsProggresRangeListeners();
    activeSmsSelectorListener();
    dispatchEvents();
  };

  startSmsValues();
};



const loadInputRangeFromSessionStorage = () => {

  const handleChange = () => {

    const smsProgressRange = document.querySelector('#sms-progress-bar .range-slider');
    const rangeValues = ['0', '20', '40', '60', '80', '100'];
    const valuesSms = [500, 1500, 5000, 10000, 20000, 50000];
    const value = smsProgressRange.getAttribute('data-value');
    const rangeValue = document.querySelector('.range-value').getAttribute('data-progress');
    smsProgressRange.parentNode.querySelector('.range-value span').innerHTML = valuesSms[rangeValues.indexOf(rangeValue)];

    if (inputRange.closest('section').classList.contains('monthly')) {
      sessionStorage.setItem('pricingGridMonthly', value);
    } else if (inputRange.closest('section').classList.contains('prepaid')) {
      sessionStorage.setItem('pricingGridPrepaid', value);
    } else if (inputRange.closest('section').classList.contains('volumen')) {
      sessionStorage.setItem('pricingGridVolumen', value);
    } else if (inputRange.closest('section').classList.contains('plan-sms')) {
      sessionStorage.setItem('pricingGridSms', value);
      sessionStorage.setItem('pricingGridSmsRangeValue', rangeValue);
      sessionStorage.setItem('pricingGridSmsPositionValue', inputRange.value);
    }
  }

  if (document.querySelector('.plan-prices section.monthly') && sessionStorage.getItem('pricingGridMonthly')) {
    document.querySelector('.grid-planes .row[data-value="' + sessionStorage.getItem('pricingGridMonthly') + '"]').click();
  } else if (document.querySelector('.plan-prices section.prepaid') && sessionStorage.getItem('pricingGridPrepaid')) {
    document.querySelector('.grid-planes .row[data-value="' + sessionStorage.getItem('pricingGridPrepaid') + '"]').click();
  } else if (document.querySelector('.plan-prices section.volumen') && sessionStorage.getItem('pricingGridVolumen')) {
    document.querySelector('.grid-planes .row[data-value="' + sessionStorage.getItem('pricingGridVolumen') + '"]').click();
  } else if (document.querySelector('.plan-prices section.plan-sms') && sessionStorage.getItem('pricingGridSms')) {
    document.querySelector('.range-slider').setAttribute('data-value', sessionStorage.getItem('pricingGridSms'));
    document.querySelector('.range-slider').value = sessionStorage.getItem('pricingGridSmsPositionValue');
    document.querySelector('.range-slider').click();
    document.querySelector('.range-value').setAttribute('data-progress', sessionStorage.getItem('pricingGridSmsRangeValue'));
    document.querySelector('.range-value span').innerHTML = sessionStorage.getItem('pricingGridSms');
    document.querySelector('.progress-anchor').style.width = sessionStorage.getItem('pricingGridSmsRangeValue') + '%';

    document.querySelectorAll('#sms-grid-plans > .row').forEach(function (element) {
      const smsPrice = element.querySelector('.sms-price').getAttribute('data-price');
      const smsBudget = document.querySelector('#plan-sms-input').getAttribute('data-value');
      element.querySelector('.column > .price > .value').innerHTML = addCommas(Math.round(smsBudget * smsPrice));
    });

  }

  const inputRange = document.querySelector('.range-slider');
  inputRange.addEventListener('change', handleChange);
  inputRange.addEventListener('input', handleChange);
  inputRange.dispatchEvent(new Event('change'));

}




const setListeners = () => {
  viewMoreCountriesListener();
  viewMoreButtonListener();
  inputRangeSmsListener();
}

const loadSmsScript = async () => {
  await setListeners();
  loadSmsPrices();
  setSmsStateButton();
  loadInputRangeFromSessionStorage();
}

export { loadSmsScript }
